import { Helmet } from "react-helmet";
import Header from "./Header";
import { Box, Container } from "@mui/material";
import { useTranslation } from "react-i18next";

const LandingPage = () => {
  const { t } = useTranslation();
  const { t: ta } = useTranslation("auth");
  return (
    <>
      <Helmet>
        <title>{`${ta("home")} | ${t("platform")}`}</title>
      </Helmet>
      <Box
        sx={(theme) => ({
          minHeight: "100vh",
          background: `linear-gradient(150deg, ${theme.palette.primary.dark ?? theme.palette.primary.main} 0%, ${theme.palette.primary.main} 45%, ${theme.palette.secondary.main} 100%)`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 5, md: 6 },
          px: { xs: 2, md: 4 },
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            backgroundImage:
              "radial-gradient(circle at 15% 85%, rgba(255,255,255,0.07) 0%, transparent 45%), radial-gradient(circle at 85% 15%, rgba(255,255,255,0.09) 0%, transparent 45%)",
            pointerEvents: "none",
          },
        })}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
          <Header />
        </Container>
      </Box>
    </>
  );
};
export default LandingPage;
